import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";

export class RefreshContractorCommand extends BaseCommand {
  CommandName = "RefreshContractor";
  Command: CONTRACTOR_TYPES;
  constructor(sessionId: string, operationId: string, contractorType: CONTRACTOR_TYPES) {
    super(sessionId, operationId);
    this.Command = contractorType;
  }
}
